import { useEffect } from "react";

/** WKWebView pans its visual viewport when focusing a field above the keyboard.
 * Keep the decorative status-area cover at that visible origin. */
export function useNativeStatusBarOffset(enabled: boolean) {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!enabled || !viewport) return;
    const style = document.documentElement.style;
    const update = () => {
      const offset = Number.isFinite(viewport.offsetTop) ? Math.max(0, viewport.offsetTop) : 0;
      style.setProperty("--eal-status-viewport-offset", `${offset}px`);
    };
    update();
    viewport.addEventListener("resize", update);
    viewport.addEventListener("scroll", update);
    return () => {
      viewport.removeEventListener("resize", update);
      viewport.removeEventListener("scroll", update);
      style.removeProperty("--eal-status-viewport-offset");
    };
  }, [enabled]);
}
